import { PropTypes } from 'prop-types';

export const videoInfoPropTypes = PropTypes.shape({
  alignmentIssue: PropTypes.string,
  alignmentLastUpdated: PropTypes.string,
  alignmentStatus: PropTypes.string,
  awayTeam: PropTypes.string,
  competition: PropTypes.string,
  countryName: PropTypes.string,
  eventsUpdated: PropTypes.string,
  homeTeam: PropTypes.string,
  matchDate: PropTypes.string,
  matchTime: PropTypes.string,
  periodEnd: PropTypes.number,
  periodStart: PropTypes.number,
  seasonName: PropTypes.string,
});

export default { videoInfoPropTypes };
